import { DualAxes } from "@ant-design/plots";
import styled from "@emotion/styled";
import { Col, Row, Table } from "antd";
import { ColumnsType } from "antd/es/table/interface";
import line3 from "../../../../images/line3.png";
import xiangmuchanzhi from "../../../../images/xiangmuchanzhi.png";
import xiangmuchanzhi1 from "../../../../images/xiangmuchanzhi1.png";
import xiangmuchanzhi2 from "../../../../images/xiangmuchanzhi2.png";
import xiangmuchanzhi4 from "../../../../images/xiangmuchanzhi4.png";
import th from "../../../../images/th1.png";
import tr from "../../../../images/tr.png";
import { useCallback, useEffect, useRef, useState } from "react";
import request from "../../../../utils/request";
import { Column } from "@ant-design/plots";
import YearPicker from "../../../../components/YearPicker";
import dayjs from "dayjs";

const Layout = styled.div`
  .flex {
    display: flex;
  }
  .ac {
    align-items: center;
  }
  .column {
    flex-direction: column;
  }
  .energy-box {
    width: 1545px;
  }
  .box-item {
    background-color: rgba(1, 104, 126, 0.9);
    border: 2px solid #00c9d0;
    box-shadow: 0 0 12px #00383f;
    border-radius: 8px;
    padding: 20px 25px;
    width: 100%;
    margin-top: 15px;
  }
  .flex1 {
    flex: 1;
  }
  .base-info-btn {
    color: #fff;
    font-weight: bold;
    font-size: 20px;

    align-items: center;
    img {
      margin-right: 5px;
    }
    span {
      margin-left: 8px;
    }
  }

  .tongji-info {
    margin-right: 23px;
    img {
      width: 50px;
      height: 50px;
      margin-right: 23px;
    }
    .tongji-info-cont {
      .value {
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #36c8da;
        text-align: center;
      }
      .label {
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #ffffff;

        text-align: center;
      }
    }
  }
  .tongji-row {
    margin-top: 50px;
    .ant-col {
      margin-bottom: 40px;
    }
  }

  .chart-box {
    margin-top: 45px;
    .chart-title {
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #d6fdff;
      margin-bottom: 46px;
    }
  }

  .table-box {
    margin-top: 55px;
  }

  .ant-table {
    background-color: transparent;
    thead {
      background-image: url(${th});
    }
    th {
      background-color: transparent !important;
      color: #fff !important;
      font-size: 14px !important;
      border: none !important;
      height: 40px !important;
      padding: 0 !important;
      &::before {
        display: none !important;
      }
    }
    td {
      color: #1cfbff !important;
      border: none !important;
      background-color: transparent !important;
    }
    tr:hover {
      td {
        background-color: transparent !important;
        border: none !important;
      }
    }
    tbody tr {
      background-image: url(${tr});
      border: none !important;
      &:nth-child(odd) {
        // background-image: url();
      }
    }
  }
`;

export const Energy: React.FC<{ id?: number }> = ({ id }) => {
  const [details, setDetails] = useState<Record<string, any>>({});
  const currentDate = useRef<any>(null);
  const getData = useCallback(() => {
    if (!id) return;
    request
      .get("/screen/Index/getCompanyPower", {
        params: {
          id: id,
          date: currentDate.current
            ? dayjs(currentDate.current).format("YYYY-MM")
            : "2022-12",
          date1: currentDate.current
            ? dayjs(currentDate.current).format("YYYY")
            : "2022",
        },
      })
      .then((res) => {
        setDetails(res.data.data || {});
      });
  }, [id]);
  useEffect(() => {
    getData();
  }, [id]);

  const columns: ColumnsType<any> = [
    {
      title: "序号",
      dataIndex: "",
      align: "center",
      render(value, record, index) {
        return index + 1;
      },
    },
    {
      title: "预警内容",
      align: "center",
      dataIndex: "desc",
    },
  ];
  const data = [
    {
      type: "Mon",
      value: 455,
      count: 20,
    },
    {
      type: "Tue",
      value: 766,
      count: 10,
    },
    {
      type: "Wed",
      value: 345,
      count: 50,
    },
    {
      type: "Thu",
      value: 500,
      count: 80,
    },
    {
      type: "Fri",
      value: 200,
      count: 40,
    },
    {
      type: "Fri2",
      value: 200,
      count: 40,
    },
    {
      type: "Fri3",
      value: 200,
      count: 40,
    },
    {
      type: "Fri4",
      value: 200,
      count: 40,
    },
    {
      type: "Fri5",
      value: 200,
      count: 40,
    },

    {
      type: "Sat",
      value: 200,
      count: 20,
    },
    {
      type: "Sun",
      value: 200,
      count: 65,
    },
  ];

  const config: React.ComponentProps<typeof DualAxes> = {
    height: 208,
    data: [data, data],
    xField: "type",
    yField: ["value", "count"],
    legend: {
      itemName: {
        formatter(text) {
          return text === "value" ? "月度" : "累计";
        },
        style: {
          fill: "#fff",
        },
      },
    },
    meta: {
      count: {
        formatter(value) {
          return `${value}亿元`;
        },
      },
    },
    tooltip: {
      formatter(datum) {
        return {
          name: datum.count !== undefined ? "累计" : "月度",
          value: datum.count || datum.value,
        };
      },
    },

    geometryOptions: [
      {
        geometry: "column",
      },
      {
        geometry: "line",
        lineStyle: {
          lineWidth: 2,
        },
      },
    ],
  };

  const columnConfig: React.ComponentProps<typeof Column> = {
    height: 208,
    data,
    xField: "type",
    yField: "value",
    seriesField: "",
    color: () => "#00F6FF",
    maxColumnWidth: 20,

    xAxis: {
      label: {
        autoHide: true,
        autoRotate: false,
      },
      // grid: {
      //   line: {
      //     style: {
      //       opacity: 0,
      //     },
      //   },
      // },
    },
    yAxis: {
      grid: {
        line: {
          style: {
            opacity: 0,
          },
        },
      },
    },
  };

  return (
    <Layout>
      <div className="energy-box">
        <Row gutter={15}>
          <Col span={12}>
            <div className="box-item">
              <div className="base-info-btn flex">
                <img src={line3} width="7" height="21" alt="" />
                <span>用电量统计</span>

                <YearPicker
                  format="YYYY-MM"
                  style={{
                    width: 130,
                  }}
                  onChange={(e) => {
                    currentDate.current = e;
                    getData();
                  }}
                />
              </div>
              <Row gutter={20} className="tongji-row">
                <Col span={12}>
                  <div className="flex tongji-info ac">
                    <img src={xiangmuchanzhi} alt="" />
                    <div className="tongji-info-cont">
                      <div className="value">{details.month_power}</div>
                      <div className="label">本月用电量（kw·h）</div>
                    </div>
                  </div>
                </Col>
                <Col span={12}>
                  <div className="flex tongji-info ac">
                    <img src={xiangmuchanzhi1} alt="" />
                    <div className="tongji-info-cont">
                      <div className="value">
                        {details.month_power_tqusage}%
                      </div>
                      <div className="label">本月用电量同比</div>
                    </div>
                  </div>
                </Col>
                <Col span={12}>
                  <div className="flex tongji-info ac">
                    <img src={xiangmuchanzhi4} alt="" />
                    <div className="tongji-info-cont">
                      <div className="value">{details.years_power}</div>
                      <div className="label">本年累计用电量（kw·h）</div>
                    </div>
                  </div>
                </Col>
                <Col span={12}>
                  <div className="flex tongji-info ac">
                    <img src={xiangmuchanzhi2} alt="" />
                    <div className="tongji-info-cont">
                      <div className="value">
                        {details.years_power_tqusage}%
                      </div>
                      <div className="label">本年累计用电量同比</div>
                    </div>
                  </div>
                </Col>
              </Row>

              <div className="chart-box">
                <div className="chart-title">用电量趋势</div>

                {details.line_power && (
                  <DualAxes
                    {...config}
                    data={Array(2).fill(
                      details.line_power.categories.map(
                        (subItem: string, subIndex: number) => ({
                          type: subItem,
                          value: details.line_power.column[subIndex],
                          count: details.line_power.line[subIndex],
                        })
                      )
                    )}
                  />
                )}
              </div>
              <div className="table-box">
                <Table
                  columns={columns}
                  pagination={false}
                  dataSource={details.list_power_logs || []}
                  locale={{
                    emptyText: "暂无数据",
                  }}
                />
              </div>
            </div>
          </Col>
          <Col span={12}>
            <div className="box-item">
              <div className="base-info-btn flex">
                <img src={line3} width="7" height="21" alt="" />
                <span>用水量统计</span>
                <YearPicker
                  format="YYYY-MM"
                  style={{
                    width: 130,
                  }}
                  onChange={(e) => {
                    currentDate.current = e;
                    getData();
                  }}
                />
              </div>
              <Row gutter={20} className="tongji-row">
                <Col span={12}>
                  <div className="flex tongji-info ac">
                    <img src={xiangmuchanzhi} alt="" />
                    <div className="tongji-info-cont">
                      <div className="value">{details.month_water}</div>
                      <div className="label">本阶段用水量（m³）</div>
                    </div>
                  </div>
                </Col>
                <Col span={12}>
                  <div className="flex tongji-info ac">
                    <img src={xiangmuchanzhi1} alt="" />
                    <div className="tongji-info-cont">
                      <div className="value">
                        {details.month_water_tqusage}%
                      </div>
                      <div className="label">本阶段用水量同比</div>
                    </div>
                  </div>
                </Col>
                <Col span={12}>
                  <div className="flex tongji-info ac">
                    <img src={xiangmuchanzhi4} alt="" />
                    <div className="tongji-info-cont">
                      <div className="value">{details.years_water}</div>
                      <div className="label">本年累计用水量（m³）</div>
                    </div>
                  </div>
                </Col>
                <Col span={12}>
                  <div className="flex tongji-info ac">
                    <img src={xiangmuchanzhi2} alt="" />
                    <div className="tongji-info-cont">
                      <div className="value">
                        {details.years_water_tqusage}%
                      </div>
                      <div className="label">本年累计用水量同比</div>
                    </div>
                  </div>
                </Col>
              </Row>

              <div className="chart-box">
                <div className="chart-title">用水量趋势</div>

                {details.line_water && (
                  <Column
                    {...columnConfig}
                    data={details.line_water.categories?.map(
                      (item: any, index: number) => {
                        return {
                          type: item,
                          value: details.line_water.column[index],
                        };
                      }
                    )}
                  />
                )}
              </div>
              <div className="table-box">
                <Table
                  columns={columns}
                  pagination={false}
                  dataSource={details.list_water_logs || []}
                  locale={{
                    emptyText: "暂无数据",
                  }}
                />
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </Layout>
  );
};
